/**
 * Created by decipaliz on 20.12.2023
 */

const EditorGoalsView = cleverapps.Layout.extend({
    ctor: function (goals) {
        GoalViewFactory.init();
        const level = LevelManager.getInstance().level;
        const views = goals.map((goal) => {
            const goalView = new EditorGoalView(goal);

            goalView.baseScale = 0.8;
            goalView.setScale(goalView.baseScale);

            if (level.isHard()) {
                goalView.setColor(cleverapps.styles.COLORS.HARD);
            }
            return goalView;
        }, this);

        this._super(views, {
            direction: cleverapps.UI.HORIZONTAL,
            margin: cleverapps.styles.EditorGoalsView.margin
        });
        this.setAlignment(cleverapps.styles.EditorGoalsView);
    }
});

cleverapps.styles.EditorGoalsView = {
    x: { align: "center", dx: 40 },
    y: { align: "top", dy: -70 },
    margin: 20
};
